import React from 'react';

import { useTranslation } from 'react-i18next';

import FilledButton from 'components/application/buttons/FilledButton';
import TextButton from 'components/application/buttons/TextButton';
import ModalBox from 'components/application/ModalBox';

export default function TrainingDestroyModal({
  currentTraining,
  deleteTraining,
  isOpen,
  setIsOpen,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'training.TrainingDestroyModal',
  });

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const closeModalBox = () => {
    setIsOpen(false);
  };

  const handleDeleteClick = () => {
    closeModalBox();
    deleteTraining();
  };

  return (
    <ModalBox
      customFooter={
        <div className='modalbox__footer-actions modalbox__footer-actions--right'>
          <TextButton
            className='tw-mr-12'
            color='blue'
            onClick={closeModalBox}
            size='md'
          >
            {i18nTShared('cancel')}
          </TextButton>
          <FilledButton color='red' onClick={handleDeleteClick}>
            {i18nT('button')}
          </FilledButton>
        </div>
      }
      isOpen={isOpen}
      mode='letterbox'
      onClose={closeModalBox}
      usingStandardDimensions={true}
    >
      <>
        <div className='modalbox-header tw-border-grey-100'>
          <h2 className='modalbox-header__title truncated-text-container tw-text-l tw-font-semibold tw-text-grey-900'>
            {i18nT('title', {
              courseName: currentTraining.course?.attributes.name,
              interpolation: { escapeValue: false },
            })}
          </h2>
        </div>
        <div className='modalbox-body'>{i18nT('description')}</div>
      </>
    </ModalBox>
  );
}
